import type { ReactNode } from 'react';
import { GoogleAnalytics } from './google';
import { PostHogProvider } from './posthog/client';

type AnalyticsProviderProps = {
  readonly children: ReactNode;
};

// PostHog and Google Analytics only. The apps deploy to Netlify, so the
// Vercel Analytics component that used to sit here requested
// /_vercel/insights/script.js from a host that has no such route: a 404 in
// every visitor's console and no data anywhere.
export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  const isProduction = process.env.NODE_ENV !== 'development';
  const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

  return (
    <>
      {isProduction ? <PostHogProvider>{children}</PostHogProvider> : children}
      {isProduction && gaMeasurementId && (
        <GoogleAnalytics gaId={gaMeasurementId} />
      )}
    </>
  );
};
